// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__NHlvv","selected":"tag_selected__JSyz_","small":"tag_small___11MH"};